import { render, staticRenderFns } from "./MealFeedbackPanel.vue?vue&type=template&id=3ce182f4&scoped=true&"
import script from "./MealFeedbackPanel.vue?vue&type=script&lang=js&"
export * from "./MealFeedbackPanel.vue?vue&type=script&lang=js&"
import style0 from "./MealFeedbackPanel.vue?vue&type=style&index=0&id=3ce182f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce182f4",
  null
  
)

export default component.exports